import { render, staticRenderFns } from "./CvStyling.vue?vue&type=template&id=357e84e1&lang=pug&"
import script from "./CvStyling.vue?vue&type=script&lang=ts&"
export * from "./CvStyling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('357e84e1')) {
      api.createRecord('357e84e1', component.options)
    } else {
      api.reload('357e84e1', component.options)
    }
    module.hot.accept("./CvStyling.vue?vue&type=template&id=357e84e1&lang=pug&", function () {
      api.rerender('357e84e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cvtool-pages/cv-sections/CvStyling.vue"
export default component.exports